import React, {useEffect, useState} from 'react';
import {
   View,
   Text,
   StyleSheet,
   TextInput,
   TouchableOpacity,
   Platform,
   Image,
   NativeModules,
   Alert,
} from 'react-native';
import {
   AccountSignIn,
   ACCOUNT_EMAIL,
   ACCOUNT_PASSWORD,
   appBackgroundWhiteBG,
   AUTHDATA,
   base100,
   buttonBorderColor,
   CONTACT_US,
   DoNotHaveAnAccount,
   FORGOT_PASSWORD,
   GET_LOGIN,
   NORCAT_ORG,
   primaryColor400,
   primaryColor500,
   primaryState300,
   primaryState800,
   QrSignIn,
   redirectToBrowser,
   REMEMBER_ACCOUNT,
   SignIn,
   white,
   FONT_FAMILY_SEMI_BOLD,
   FONT_FAMILY_REGULAR,
   FONT_FAMILY_MEDIUM,
   loginErrorMessage,
   GET_USER_PROFILE,
   isNewAPI,
   gray,
   rememberAccount,
   isWindows,
   isDesktop,
   primaryColor700,
   hoverBtnBgColor,
   primaryColor800,
   BACK_BUTTON_HOVER_COLOR,
   FONT_FAMILY_BOLD,
   primaryState500,
   isHoverEnabled,
   isWeb,
   togglePassword,
   isMacOS,
   Reset,
   ResetPassword,
   ResettingPassword,
   ConfirmPassword,
   NewPassword,
   CurrentPassword,
   WHITE_BUTTON_HOVER_COLOR,
   cancel,
   BUTTON_HOVER_COLOR,
   confirm,
   RESET_PASSWORD,
   CurrentPasswordValidation,
   NewPasswordValidation,
   PasswordMatchValidation,
   PasswordResetError,
   pwdValidation,
   validatePassword,
   isiOS,
} from '../../utils/utils';
import RNFS from '../../components/fs';
import {useDispatch, useSelector} from 'react-redux';
import {useIsFocused, useNavigation} from '@react-navigation/native';
import {selectBarcode, setBarcode} from '../../redux/slices/ScannerSlice';
import {retrieveAppData, storeAppData} from '../../utils/preference';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {apiPostRequest, logoutHandler} from '../../service/network_access';
import ThreeDotsLoader from '../../utils/norcat_loading';
import {setSignIn} from '../../redux/slices/AuthSlice';
// import {BarcodeScanner} from 'react-native-barcode-zxing';
import logger from '../../utils/logger';
import {HoverStyle} from '../../utils/hover_style';
import {ContactUsLink, NorcatOrgBtn} from '../../components/common';
import {isMobile, isSafari, isTablet} from 'react-device-detect';
import PasswordHint from '../../components/password';
import ThreeDotsLoaderWindows from '../../utils/norcat_loading_windows';
import ErrorView from '../login/error';

export const ResetPasswordView = props => {
   const isIOS = Platform.OS === 'ios';
   const isAndroid = Platform.OS === 'android';
   const isMobilePlatform = isIOS || isAndroid;
   const [isNewPasswordFocused, setIsNewPasswordFocused] = useState(false);
   const [isPasswordFocused, setIsPasswordFocused] = useState(false);
   const [isError, setIsError] = useState(false);
   const [isApiLoading, setIsApiLoading] = useState(false);
   const [errorMessage, setErrorMessage] = useState('');
   const [newPassword, setNewPassword] = useState('');
   const [confirmPassword, setConfirmPassword] = useState('');
   const [checked, setChecked] = useState(false);
   const dispatch = useDispatch();
   const navigation = useNavigation();
   const barCodeScanned = useSelector(selectBarcode);
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const [isHover, setHover] = useState(false);
   const [txt1Hover, setTxt1Hover] = useState(false);
   const [txt2Hover, setTxt2Hover] = useState(false);
   const [checkHover, setChkHover] = useState(false);
   const [cancelHover, setCancelHover] = React.useState(false);
   const [confirmHover, setConfirmlHover] = React.useState(false);
   const [isResetSuccess, setResetSuccess] = useState(false);

   let isMounted = true;
   const isScreenFocused = useIsFocused();

   if (barCodeScanned !== '') {
      navigation.goBack();
      const barcodeData = {barcode: ''};
      dispatch(setBarcode(barcodeData));
   }

   //State variable to track password visibility
   const [showNewPassword, setShowNewPassword] = useState(false);
   const [showConfirmPassword, setShowConfirmPassword] = useState(false);

   // Function to toggle the password visibility state
   const toggleShowPassword = field => {
      if (field === NewPassword) setShowNewPassword(!showNewPassword);
      else setShowConfirmPassword(!showConfirmPassword);
   };

   const newPasswordHandleFocus = () => {
      setIsNewPasswordFocused(true);
      setIsPasswordFocused(false);
   };
   const newPasswordHandleBlur = () => {
      setIsNewPasswordFocused(false);
   };

   const passwordHandleFocus = () => {
      setIsNewPasswordFocused(false);
      setIsPasswordFocused(true);
   };
   const passwordHandleBlur = () => {
      setIsPasswordFocused(false);
   };

   const borderNewPasswordStyle = {
      borderWidth: 1,
      borderColor: isNewPasswordFocused ? primaryColor500 : primaryState300,
   };

   const borderPasswordStyle = {
      borderWidth: 1,
      borderColor: isPasswordFocused ? primaryColor500 : primaryState300,
   };

   const inputWebRef = React.useRef();

   useEffect(() => {
      if (isWeb) {
         const INTV = setInterval(() => {
            if (
               inputWebRef.current &&
               !isNewPasswordFocused &&
               !isPasswordFocused &&
               isHoverEnabled
            ) {
               inputWebRef?.current?.focus();
            }
         }, 1000);
         return () => clearInterval(INTV);
      }
   }, [isNewPasswordFocused, isPasswordFocused]);

   function onPasswordReset() {
      if (newPassword === '') {
         setIsError(true);
         setErrorMessage(NewPasswordValidation);
      } else if (newPassword !== confirmPassword) {
         setIsError(true);
         setErrorMessage(PasswordMatchValidation);
      } else if (!validatePassword(newPassword)) {
         setIsError(true);
         setErrorMessage(pwdValidation);
      } else {
         handleResetPassword();
      }
   }

   function handleLogout() {
      const user = {
         isLoggedIn: false,
         userName: '',
      };
      Platform.OS === 'web' ? logoutHandler() : dispatch(setSignIn(user));
      navigation.goBack();
   }

   async function handleResetPassword() {
      const authData = await retrieveAppData(AUTHDATA);
      const data = JSON.parse(authData);
      const reqParms = {
         theData: JSON.stringify({
            NewPassword: newPassword,
            ConfirmNewPassword: newPassword,
            EmployeeKey: data.EmployeeKey,
         }),
      };
      setIsApiLoading(true);
      try {
         const res = await apiPostRequest({
            url: RESET_PASSWORD,
            parms: reqParms,
         });
         try {
            setIsApiLoading(false);
            if (res.StatusResult) {
               logger('Success Response:: ' + JSON.stringify(res));
               setIsError(true);
               setResetSuccess(true);
               setErrorMessage(res.StatusMessage);
            } else if (typeof res === 'string') {
               logger('Exception Response:: ' + res);
               setIsError(true);
               setErrorMessage(res);
            } else {
               logger('Error Response:: ' + res);
               setIsError(true);
               setErrorMessage(res.StatusMessage);
            }
         } catch (error) {
            logger('Error in login::', error);
         }
      } catch (error) {
         logger('Error in login::', error);
      }
   }

   const handleKeyDown = event => {
      if (event.nativeEvent.key === 'Enter') {
         onPasswordReset();
      }
   };

   function handleRetryClick() {
      if (isResetSuccess) {
         storeAppData(ACCOUNT_PASSWORD, '');
         storeAppData(REMEMBER_ACCOUNT, 'false');
         setResetSuccess(false);
         handleLogout();
      }
      setIsError(false);
   }

   return (
      <View>
         <View
            style={{
               justifyContent: 'flex-start',
               alignItems: 'center',
               borderColor:
                  Platform.OS === 'windows' ? 'rgba(158, 150, 150, 0.2)' : null,
               borderWidth: Platform.OS === 'windows' ? 2 : null,
               borderRadius: Platform.OS === 'windows' ? 10 : null,
            }}>
            <View
               style={[
                  styles.card,
                  {
                     minHeight: !isLandscapeMode
                        ? 224
                        : isWeb
                        ? 280
                        : isDesktop
                        ? 300
                        : isError
                        ? 320
                        : isLandscapeMode && isiOS
                        ? 350
                        : 380,
                     marginTop: !isLandscapeMode ? 5 : null,
                  },
               ]}>
               {isError ? (
                  <ErrorView
                     title={isResetSuccess ? 'Alert!' : PasswordResetError}
                     message={errorMessage}
                     buttonText={isResetSuccess ? 'OK' : 'Retry'}
                     onRetry={handleRetryClick}
                     headerIcon={
                        isResetSuccess
                           ? require('../../assets/resetpassword.png')
                           : require('../../assets/error_reset.png')
                     }
                  />
               ) : isApiLoading ? (
                  isWindows ? (
                     <ThreeDotsLoaderWindows title={ResettingPassword} />
                  ) : isMacOS ? (
                     <ThreeDotsLoader title={ResettingPassword} />
                  ) : (
                     <View
                        style={{
                           padding: isLandscapeMode ? 32 : 24,
                           flex: 1,
                        }}>
                        <ThreeDotsLoader title={ResettingPassword} />
                     </View>
                  )
               ) : (
                  <View
                     style={[
                        styles.cardContent,
                        {
                           paddingVertical:
                              props.isPortrait && isAndroid ? 16 : 24,
                        },
                     ]}>
                     {isWeb && (
                        <TextInput
                           ref={inputWebRef}
                           style={{
                              height: 0,
                              width: 0,
                           }}
                           autoFocus={isHoverEnabled} //For enter key event in web platform
                           onKeyPress={event => {
                              if (event.nativeEvent.key === 'Enter') {
                                 onPasswordReset();
                              }
                           }}
                        />
                     )}
                     <Text
                        style={[
                           styles.sectionTitle,
                           {
                              marginBottom:
                                 props.isPortrait && isAndroid ? 10 : 16,
                           },
                        ]}>
                        {ResetPassword}
                     </Text>

                     <View style={styles.line} />

                     <View
                        style={{
                           justifyContent: 'center',
                           alignSelf: 'stretch',
                        }}>
                        <TextInput
                           style={[
                              styles.inputStyle,
                              borderNewPasswordStyle,
                              {
                                 paddingRight:
                                    isSafari && isLandscapeMode ? 35 : 30,
                              },
                           ]}
                           underlineColorAndroid={'rgba(0,0,0,0)'}
                           placeholder={NewPassword}
                           placeholderTextColor={gray}
                           value={newPassword}
                           color="#000000"
                           onChangeText={password => setNewPassword(password)}
                           secureTextEntry={!showNewPassword}
                           onFocus={newPasswordHandleFocus}
                           onBlur={newPasswordHandleBlur}
                           onKeyPress={handleKeyDown}
                           autoComplete={
                              isMobilePlatform ? 'off' : 'new-password'
                           }
                           textContentType="none"
                           key={showNewPassword ? 'secure' : 'nonsecure'}
                           /** To resolve mac issue above key is used */
                        />
                        {togglePassword && (
                           <PasswordHint
                              onPress={() => toggleShowPassword(NewPassword)}
                              isLandscapeMode={isLandscapeMode}
                              showPassword={showNewPassword}
                           />
                        )}
                     </View>

                     <View
                        style={{
                           justifyContent: 'center',
                           alignSelf: 'stretch',
                        }}>
                        <TextInput
                           style={[
                              styles.inputStyle,
                              borderPasswordStyle,
                              {
                                 paddingRight:
                                    isSafari && isLandscapeMode ? 35 : 30,
                              },
                           ]}
                           underlineColorAndroid={'rgba(0,0,0,0)'}
                           placeholder={ConfirmPassword}
                           placeholderTextColor={gray}
                           value={confirmPassword}
                           color="#000000"
                           onChangeText={password =>
                              setConfirmPassword(password)
                           }
                           secureTextEntry={!showConfirmPassword}
                           onFocus={passwordHandleFocus}
                           onBlur={passwordHandleBlur}
                           onKeyPress={handleKeyDown}
                           autoComplete={
                              isMobilePlatform ? 'off' : 'new-password'
                           }
                           textContentType="none"
                           key={showConfirmPassword ? 'secure' : 'nonsecure'}
                           /** To resolve mac issue above key is used */
                        />
                        {togglePassword && (
                           <PasswordHint
                              onPress={() =>
                                 toggleShowPassword(ConfirmPassword)
                              }
                              isLandscapeMode={isLandscapeMode}
                              showPassword={showConfirmPassword}
                           />
                        )}
                     </View>

                     <View
                        style={{
                           flexDirection: isMobilePlatform
                              ? 'column-reverse'
                              : 'row',
                           marginTop: 16,
                           width: '100%',
                        }}>
                        <View
                           style={{
                              flex: 1,
                              marginTop:
                                 isLandscapeMode && !isWeb
                                    ? isDesktop
                                       ? 0
                                       : 60
                                    : isMobilePlatform
                                    ? 10
                                    : 0,
                              marginRight: isMobilePlatform ? 0 : 16,
                           }}>
                           <TouchableOpacity
                              style={{
                                 backgroundColor: cancelHover
                                    ? WHITE_BUTTON_HOVER_COLOR
                                    : white,
                                 minHeight: 48,
                                 borderRadius: 6,
                                 justifyContent: 'center',
                                 borderWidth: 1,
                                 borderColor: primaryColor400,
                                 ...Platform.select({
                                    windows: {
                                       borderWidth: 1.01,
                                    },
                                 }),
                              }}
                              onMouseEnter={() => {
                                 setCancelHover(true);
                              }}
                              onMouseLeave={() => {
                                 setCancelHover(false);
                              }}
                              onPress={() => {
                                 handleLogout();
                              }}>
                              <Text
                                 style={{
                                    color: primaryColor500,
                                    fontSize: 16,
                                    fontWeight: '500',
                                    textAlign: 'center',
                                    fontFamily: FONT_FAMILY_MEDIUM,
                                 }}>
                                 {cancel}
                              </Text>
                           </TouchableOpacity>
                        </View>
                        <View style={{flex: 1}}>
                           <TouchableOpacity
                              style={{
                                 backgroundColor: confirmHover
                                    ? BUTTON_HOVER_COLOR
                                    : primaryColor500,
                                 minHeight: 48,
                                 borderRadius: 6,
                                 justifyContent: 'center',
                              }}
                              onMouseEnter={() => {
                                 setConfirmlHover(true);
                              }}
                              onMouseLeave={() => {
                                 setConfirmlHover(false);
                              }}
                              onPress={() => {
                                 onPasswordReset();
                              }}>
                              <Text
                                 style={{
                                    color: 'white',
                                    fontSize: 16,
                                    fontWeight: '500',
                                    textAlign: 'center',
                                    fontFamily: FONT_FAMILY_MEDIUM,
                                 }}>
                                 {confirm}
                              </Text>
                           </TouchableOpacity>
                        </View>
                     </View>
                  </View>
               )}
            </View>
         </View>
         <View
            style={{
               flexDirection: 'row',
               alignItems: 'center',
               justifyContent: 'center',
               marginTop: props.isPortrait && isAndroid ? 20 : 24,
            }}>
            <Text
               style={{
                  textAlign: 'center',
                  fontWeight: '400',
                  fontSize: 14,
                  color: base100,
                  fontFamily: FONT_FAMILY_REGULAR,
               }}>
               {DoNotHaveAnAccount}
            </Text>
            <ContactUsLink />
         </View>
         <View style={{alignItems: 'center'}}>
            <NorcatOrgBtn />
         </View>
      </View>
   );
};

const styles = StyleSheet.create({
   container: {
      backgroundColor: appBackgroundWhiteBG,
      flex: 1,
      height: '100vh',
   },
   cardContainer: {
      marginTop: 24,
      marginEnd: 24,
      marginStart: 24,
      flex: 1,
   },
   card: {
      borderRadius: 5,
      elevation: 3,
      backgroundColor: '#fff',
      shadowOffset: {width: 0, height: 1},
      shadowColor: '#333',
      shadowOpacity: 0.3,
      shadowRadius: Platform.OS === 'web' ? 7 : 2,
      width: '99%',
   },
   cardContent: {
      marginVertical: 5,
      alignContent: 'center',
      justifyContent: 'flex-start',
      paddingHorizontal: 24,
   },
   sectionTitle: {
      fontSize: 20,
      fontWeight: '600',
      textAlign: 'center',
      color: primaryState800,
      fontFamily: FONT_FAMILY_SEMI_BOLD,
   },
   line: {
      height: 2,
      opacity: 0.1,
      marginHorizontal: 10,
      backgroundColor: '#000000',
      marginBottom: 24,
   },
   inputStyle: {
      width: '100%',
      backgroundColor: white,
      marginBottom: 16,
      alignItems: 'flex-end',
      borderRadius: 4,
      fontSize: isMobile ? 16 : 12, // decreasing fontSize < 15 will cause zoom issue on web-small-devices
      maxHeight: 48,
      padding: 10,
      fontWeight: '700',
      color: '#000000',
   },
   signUpButton: {
      backgroundColor: primaryColor500,
      minHeight: 48,
      borderRadius: 6,
      justifyContent: 'center',
   },
   qrButton: {
      backgroundColor: white,
      minHeight: 48,
      borderRadius: 6,
      justifyContent: 'center',
      marginTop: 10,
      borderWidth: 1,
      borderColor: buttonBorderColor,
   },
   buttonText: {
      color: 'white',
      fontSize: 16,
      fontWeight: '500',
      textAlign: 'center',
      fontFamily: FONT_FAMILY_MEDIUM,
   },
});
